import React from 'react';

import { formValidators } from '../../utils/formValidation';
import formDataStorage from '../../utils/formDataStorage';
import { Plus, Trash2, Users, Building2, User, ChevronDown } from 'lucide-react';

// 旅行伙伴信息表单
const TravelCompanionsInfoForm = ({ data, onChange }) => {

  // 从formDataStorage读取数据并确保数据同步
  React.useEffect(() => {
    console.log('TravelCompanionsInfoForm useEffect - 初始化数据检查');
    const savedData = formDataStorage.loadFormData('travel_companions_info');
    console.log('TravelCompanionsInfoForm useEffect - 已保存数据:', savedData);
    console.log('TravelCompanionsInfoForm useEffect - 当前props数据:', data);
    
    // 如果有保存的数据但当前data为空或部分字段缺失，则从数据库加载
    if (savedData && (!data || Object.keys(data).length === 0)) {
      console.log('TravelCompanionsInfoForm useEffect - 从数据库加载数据');
      Object.keys(savedData).forEach(key => {
        if (savedData[key] !== null && savedData[key] !== undefined) {
          onChange(key, savedData[key]);
        }
      });
    }
  }, [data, onChange]);
  // 关系选项映射
  const RELATIONSHIP_OPTIONS = [
    { value: 'P', label: 'P - 父母 (Parent)' },
    { value: 'S', label: 'S - 配偶 (Spouse)' },
    { value: 'C', label: 'C - 子女 (Child)' },
    { value: 'B', label: 'B - 兄弟姐妹 (Brother/Sister)' },
    { value: 'F', label: 'F - 朋友 (Friend)' },
    { value: 'R', label: 'R - 其他亲戚 (Relative)' },
    { value: 'E', label: 'E - 雇主/同事 (Employer/Colleague)' },
    { value: 'O', label: 'O - 其他 (Other)' }
  ];

  // 添加同行人员
  const addPersonInfo = () => {
    const currentPersonInfo = data.person_info || [];
    const newPersonInfo = [...currentPersonInfo, { surnames: '', given_name: '', relationship: '' }];
    onChange('person_info', newPersonInfo);
  };

  // 删除同行人员
  const removePersonInfo = (index) => {
    const currentPersonInfo = data.person_info || [];
    const newPersonInfo = currentPersonInfo.filter((_, i) => i !== index);
    onChange('person_info', newPersonInfo);
  };

  // 更新同行人员信息
  const updatePersonInfo = (index, field, value) => {
    const currentPersonInfo = data.person_info || [];
    const newPersonInfo = [...currentPersonInfo];
    if (!newPersonInfo[index]) {
      newPersonInfo[index] = { surnames: '', given_name: '', relationship: '' };
    }
    newPersonInfo[index] = { ...newPersonInfo[index], [field]: value };
    onChange('person_info', newPersonInfo);
  };

  // 获取关系显示名称
  const getRelationshipLabel = (code) => {
    const option = RELATIONSHIP_OPTIONS.find(opt => opt.value === code);
    return option ? option.label : code;
  };

  // 使用统一的验证函数
  const validatePersonInfo = () => {
    return formValidators.travel_companions_info(data);
  };

  return (
    <div className="space-y-6">
      <div className="bg-gradient-to-r from-indigo-50 to-purple-50 p-6 rounded-lg">
        <h3 className="text-2xl font-bold text-gray-800 mb-6 flex items-center">
          <span className="w-8 h-8 bg-indigo-600 text-white rounded-full flex items-center justify-center mr-3 text-sm">👥</span>
          旅行伙伴信息
        </h3>

        {/* 是否有人同行 */}
        <div className="bg-white p-6 rounded-lg shadow-sm mb-6">
          <div className="mb-4">
            <h4 className="text-lg font-semibold text-gray-800 mb-3 flex items-center">
              <Users className="w-5 h-5 mr-2" />
              是否有其他人与您同行？
            </h4>
            <div className="flex gap-6">
              <label className="flex items-center cursor-pointer p-3 border-2 border-gray-200 rounded-lg hover:border-indigo-400 hover:bg-indigo-50 transition-all duration-200">
                <input
                  type="radio"
                  name="has_travel_companions"
                  value="false"
                  checked={(data.has_travel_companions !== undefined ? data.has_travel_companions : false) === false}
                  onChange={(e) => {
                    onChange('has_travel_companions', false);
                    onChange('group_travel', false);
                    onChange('group_name', '');
                    onChange('person_info', []);
                  }}
                  className="mr-3 w-5 h-5 text-indigo-600 border-gray-300 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-50"
                />
                <span className="text-base font-medium text-gray-700">❌ 否 - 我独自旅行</span>
              </label>
              
              <label className="flex items-center cursor-pointer p-3 border-2 border-gray-200 rounded-lg hover:border-indigo-400 hover:bg-indigo-50 transition-all duration-200">
                <input
                  type="radio"
                  name="has_travel_companions"
                  value="true"
                  checked={(data.has_travel_companions !== undefined ? data.has_travel_companions : false) === true}
                  onChange={(e) => {
                    onChange('has_travel_companions', true);
                  }}
                  className="mr-3 w-5 h-5 text-indigo-600 border-gray-300 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-50"
                />
                <span className="text-base font-medium text-gray-700">✅ 是 - 有人同行</span>
              </label>
            </div>
          </div>

          <div className="p-4 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg border-l-4 border-blue-400">
            <p className="text-sm text-blue-700">
              <strong>说明：</strong> 如果您将与其他人一起旅行（包括家人、朋友、同事等），请勾选此选项。然后选择旅行方式：<br />
              • <strong>跟随团体/组织</strong>：只需填写组织名称<br />
              • <strong>不跟随团体/组织</strong>：需要填写每个同行人员的详细信息
            </p>
          </div>
        </div>

        {/* 是否跟随团体或组织 - 只在有人同行时显示 */}
        {data.has_travel_companions&& (
          <div className="bg-white p-6 rounded-lg shadow-sm mb-6">
            <div className="mb-4">
              <h4 className="text-lg font-semibold text-gray-800 mb-3 flex items-center">
                <Building2 className="w-5 h-5 mr-2" />
                您是否跟随团体或组织旅行？
              </h4>
              <div className="flex gap-6">
                <label className="flex items-center cursor-pointer p-3 border-2 border-gray-200 rounded-lg hover:border-purple-400 hover:bg-purple-50 transition-all duration-200">
                  <input
                    type="radio"
                    name="group_travel"
                    value="false"
                    checked={(data.group_travel !== undefined ? data.group_travel : false) === false}
                    onChange={(e) => {
                      onChange('group_travel', false);
                      onChange('group_name', '');
                    }}
                    className="mr-3 w-5 h-5 text-purple-600 border-gray-300 focus:ring-2 focus:ring-purple-500 focus:ring-opacity-50"
                  />
                  <span className="text-base font-medium text-gray-700">❌ 否 - 个人同行</span>
                </label>
                
                <label className="flex items-center cursor-pointer p-3 border-2 border-gray-200 rounded-lg hover:border-purple-400 hover:bg-purple-50 transition-all duration-200">
                  <input
                    type="radio"
                    name="group_travel"
                    value="true"
                    checked={(data.group_travel !== undefined ? data.group_travel : false) === true}
                    onChange={(e) => {
                      onChange('group_travel', true);
                      onChange('person_info', []);
                    }}
                    className="mr-3 w-5 h-5 text-purple-600 border-gray-300 focus:ring-2 focus:ring-purple-500 focus:ring-opacity-50"
                  />
                  <span className="text-base font-medium text-gray-700">✅ 是 - 跟随团体/组织</span>
                </label>
              </div>
            </div>

                      {/* 团体名称输入 */}
          {data.group_travel && (
            <div className="mt-4 p-4 bg-gradient-to-r from-green-50 to-emerald-50 rounded-lg border-l-4 border-green-400">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  团体或组织名称 <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  value={data.group_name || ''}
                  onChange={(e) => onChange('group_name', e.target.value)}
                  placeholder="请输入团体或组织的完整名称"
                  className={`w-full h-12 px-4 py-3 border rounded-lg transition-all duration-200 ${
                    !data.group_name 
                      ? 'border-red-300 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent' 
                      : 'border-gray-300 bg-white focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent shadow-sm hover:shadow-md'
                  }`}
                />
                {!data.group_name && (
                  <p className="text-red-500 text-xs mt-1">请填写团体或组织名称</p>
                )}
              </div>
              <p className="text-sm text-green-700 mt-2">
                <strong>示例：</strong> 旅行社名称、公司名称、学校名称、宗教组织等
              </p>
            </div>
          )}

            <div className="mt-4 p-4 bg-gradient-to-r from-yellow-50 to-orange-50 rounded-lg border-l-4 border-yellow-400">
              <p className="text-sm text-yellow-700">
                <strong>说明：</strong> 如果您通过旅行社、公司、学校或其他组织安排此次旅行，请勾选此选项。选择后只需填写组织名称，无需填写个人同行人员信息。
              </p>
            </div>
          </div>
        )}

        {/* 同行人员详细信息 - 只在有人同行且不跟随团体时显示 */}
        {data.has_travel_companions&& !data.group_travel && (
          <div className="bg-white p-6 rounded-lg shadow-sm mb-6">
            <div className="flex items-center justify-between mb-4">
              <h4 className="text-lg font-semibold text-gray-800 flex items-center">
                <User className="w-5 h-5 mr-2" />
                同行人员详细信息
              </h4>
              <button
                type="button"
                onClick={addPersonInfo}
                className="flex items-center px-4 py-2 bg-gradient-to-r from-indigo-600 to-indigo-700 text-white rounded-lg hover:from-indigo-700 hover:to-indigo-800 transition-all duration-200 text-sm font-medium shadow-sm hover:shadow-md"
              >
                <Plus className="w-4 h-4 mr-1" />
                添加同行人员
              </button>
            </div>

            <div className="space-y-4">
              {(() => {
                const personInfo = data.person_info || [];
                const displayPersonInfo = personInfo.length === 0 ?
                  [{ surnames: '', given_name: '', relationship: '' }] : personInfo;

                return displayPersonInfo.map((person, index) => (
                  <div key={index} className="p-4 bg-gradient-to-r from-gray-50 to-indigo-50 rounded-lg border-l-4 border-indigo-400 shadow-sm">
                    <div className="flex items-center gap-3">
                      <div className="flex-1 space-y-4">
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                          {/* 姓氏 */}
                          <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                              同行人员 {index + 1} - 姓氏 <span className="text-red-500">*</span>
                            </label>
                            <input
                              type="text"
                              value={person.surnames || ''}
                              onChange={(e) => updatePersonInfo(index, 'surnames', e.target.value)}
                              placeholder="ZHANG"
                              className={`w-full h-12 px-4 py-3 border rounded-lg transition-all duration-200 ${
                                !person.surnames 
                                  ? 'border-red-300 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent' 
                                  : 'border-gray-300 bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent shadow-sm hover:shadow-md'
                              }`}
                            />
                            {!person.surnames && (
                              <p className="text-red-500 text-xs mt-1">请填写姓氏</p>
                            )}
                          </div>

                          {/* 名字 */}
                          <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                              同行人员 {index + 1} - 名字 <span className="text-red-500">*</span>
                            </label>
                            <input
                              type="text"
                              value={person.given_name || ''}
                              onChange={(e) => updatePersonInfo(index, 'given_name', e.target.value)}
                              placeholder="SAN"
                              className={`w-full h-12 px-4 py-3 border rounded-lg transition-all duration-200 ${
                                !person.given_name 
                                  ? 'border-red-300 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent' 
                                  : 'border-gray-300 bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent shadow-sm hover:shadow-md'
                              }`}
                            />
                            {!person.given_name && (
                              <p className="text-red-500 text-xs mt-1">请填写名字</p>
                            )}
                          </div>

                          {/* 关系 */}
                          <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                              与您的关系 <span className="text-red-500">*</span>
                            </label>
                            <div className="relative">
                              <select
                                value={person.relationship || ''}
                                onChange={(e) => updatePersonInfo(index, 'relationship', e.target.value)}
                                className={`w-full h-12 px-4 py-3 pr-10 border rounded-lg focus:outline-none focus:ring-2 focus:border-transparent bg-gradient-to-r from-white to-indigo-50 shadow-sm hover:shadow-md transition-all duration-200 appearance-none cursor-pointer ${
                                  !person.relationship 
                                    ? 'border-red-300 focus:ring-red-500' 
                                    : 'border-gray-300 focus:ring-indigo-500'
                                }`}
                              >
                                <option value="">请选择关系...</option>
                                {RELATIONSHIP_OPTIONS.map(option => (
                                  <option key={option.value} value={option.value}>
                                    {option.label}
                                  </option>
                                ))}
                              </select>
                              <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                                <ChevronDown className="h-4 w-4 text-gray-400" />
                              </div>
                            </div>
                            {!person.relationship && (
                              <p className="text-red-500 text-xs mt-1">请选择与您的关系</p>
                            )}
                          </div>
                        </div>

                        {/* 当前选择预览 */}
                        {(person.surnames || person.given_name || person.relationship) && (
                          <div className="p-3 bg-gradient-to-r from-green-50 to-emerald-50 rounded-lg border-l-4 border-green-400">
                            <div className="text-sm font-medium text-green-800">
                              👤 {person.surnames} {person.given_name}
                              {person.relationship && (
                                <span className="ml-2 text-green-600">
                                  ({getRelationshipLabel(person.relationship)})
                                </span>
                              )}
                            </div>
                          </div>
                        )}
                      </div>

                      {/* 删除按钮 */}
                      {displayPersonInfo.length > 1 && (
                        <button
                          type="button"
                          onClick={() => removePersonInfo(index)}
                          className="flex items-center justify-center w-10 h-10 bg-gradient-to-r from-red-500 to-red-600 text-white rounded-lg hover:from-red-600 hover:to-red-700 transition-all duration-200 shadow-sm hover:shadow-md mt-6"
                          title="删除此同行人员"
                        >
                          <Trash2 className="w-4 h-4" />
                        </button>
                      )}
                    </div>
                  </div>
                ));
              })()}
            </div>

            {/* 提示信息 */}
            <div className="mt-4 p-4 bg-gradient-to-r from-blue-50 to-cyan-50 rounded-lg border-l-4 border-blue-400">
              <h5 className="text-sm font-semibold text-blue-800 mb-2">📝 填写提示</h5>
              <ul className="text-sm text-blue-700 space-y-1">
                <li>• <strong>姓氏和名字：</strong> 请填写护照上的英文姓名</li>
                <li>• <strong>关系代码：</strong> 选择与您最接近的关系类型</li>
                <li>• <strong>多人同行：</strong> 如有多人同行，请逐一添加每个人的信息</li>
                <li>• <strong>准确性：</strong> 请确保信息与护照信息一致</li>
              </ul>
            </div>
          </div>
        )}

        {/* 预览信息 */}
        {(data.has_travel_companions|| data.group_travel) && (
          <div className="mt-6 p-4 bg-gradient-to-r from-indigo-50 to-purple-50 rounded-lg border-l-4 border-indigo-400 shadow-sm">
            <div className="flex items-center justify-between mb-2">
              <h4 className="font-semibold text-indigo-800">信息预览</h4>
              {(() => {
                const validation = validatePersonInfo();
                return (
                  <span className={`px-3 py-1 rounded-full text-xs font-medium ${
                    validation.isValid 
                      ? 'bg-green-100 text-green-800' 
                      : 'bg-red-100 text-red-800'
                  }`}>
                    {validation.isValid ? '✅ 验证通过' : '❌ 需要完善'}
                  </span>
                );
              })()}
            </div>
            <div className="text-sm text-indigo-700 space-y-1">
              <p><strong>是否有人同行:</strong> {data.has_travel_companions? '✅ 是' : '❌ 否'}</p>

              {data.has_travel_companions&& !data.group_travel && data.person_info && data.person_info.length > 0 && (
                <div>
                  <p><strong>同行人员数量:</strong> {data.person_info.length} 人</p>
                  <div className="mt-2 space-y-1">
                    {data.person_info.map((person, index) => (
                      <div key={index} className="text-xs bg-white p-2 rounded border-l-2 border-indigo-300">
                        <strong>#{index + 1}:</strong> {person.surnames} {person.given_name}
                        {person.relationship && (
                          <span className="ml-2 text-indigo-600">
                            ({getRelationshipLabel(person.relationship)})
                          </span>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {data.has_travel_companions&& data.group_travel && (
                <p><strong>旅行方式:</strong> 跟随团体/组织旅行</p>
              )}

              {data.has_travel_companions&& !data.group_travel && (
                <p><strong>旅行方式:</strong> 个人同行（非团体）</p>
              )}

              <p><strong>跟随团体/组织:</strong> {data.group_travel ? '✅ 是' : '❌ 否'}</p>

              {data.group_travel && data.group_name && (
                <p><strong>团体/组织名称:</strong> {data.group_name}</p>
              )}
            </div>

            {/* 验证错误信息 */}
            {(() => {
              const validation = validatePersonInfo();
              if (!validation.isValid && validation.errors.length > 0) {
                return (
                  <div className="mt-4 p-3 bg-red-50 rounded-lg border-l-4 border-red-400">
                    <h5 className="text-sm font-semibold text-red-800 mb-2">⚠️ 请完善以下信息：</h5>
                    <ul className="text-sm text-red-700 space-y-1">
                      {validation.errors.map((error, index) => (
                        <li key={index} className="flex items-center">
                          <span className="w-1 h-1 bg-red-500 rounded-full mr-2"></span>
                          {error}
                        </li>
                      ))}
                    </ul>
                  </div>
                );
              }
              return null;
            })()}
          </div>
        )}
      </div>
    </div>
  );
};

export default TravelCompanionsInfoForm; 
